/**
 * **層の宣言と重なり順**（Issue #522）。
 *
 * 重なり順は**この配列の順**で決まる。呼ぶ側が渡した順・置いた順には依存しない
 * —— 旧演出プレビュー（Issue #639 で削除）ではこれが JSX の並びに埋まっていて、旧 `/fx` と `/edit` の 2 か所に
 * 同じ順序が書かれていた（片方だけ直すと絵が変わる）。
 *
 * 層の中身（何をどう描くか）はこのファイルの関心ではない。ここが持つのは名前と順だけ。
 */

/** 舞台の層。**前のものの上に重なる**（後ろの要素が手前） */
export const LAYERS = Object.freeze([
  'background',   // 地の色・背景の絵
  'field',        // 盤そのもの（元動画・マット・ゾーンの枠）＝ **盤に印刷されているもの**
  'objects',      // カード・山・実写の手札 ＝ **盤に置かれているもの**（動きは最小）
  'effects',      // 盤の上に乗る演出（**帯**を持つ）
  'hud',          // ターン・LP・手札など、盤の外の表示
  'front',        // **HUD より手前**の演出（層の `front: true`。飛び出すカードなど。書き出しにも出す）
  'edit',         // 編集のための補助（枠のドラッグ・目安の線）。書き出しには出さない
]);

const INDEX = new Map(LAYERS.map((name, i) => [name, i]));

/** その名前が層として宣言されているか */
export const isLayer = (name) => INDEX.has(name);

/**
 * 層の要素を**宣言の順**に並べる。同じ層の中だけは渡された順を保つ（安定な並べ替え）。
 * 知らない層の名前は落とす（黙って一番上に出ると原因が分からなくなるため）。
 *
 * @param {{layer: string, key: string, node: any}[]} entries
 * @returns 同じ形の配列（`LAYERS` の順）
 */
export function orderLayers(entries) {
  return (entries ?? [])
    .filter((e) => e && isLayer(e.layer))
    .map((e, i) => ({ e, i }))
    .sort((a, b) => (INDEX.get(a.e.layer) - INDEX.get(b.e.layer)) || (a.i - b.i))
    .map(({ e }) => e);
}
